/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
export class DialogItem {
  id: number;
  code: string;
  label: string;
  order: number;
  uuid: string;
}
